import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpeakerSimpleHigh = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7234 10.4626C17.0973 10.8021 17.3599 11.3249 17.3599 11.9998C17.3599 12.6749 17.0973 13.1975 16.7234 13.5371",
			stroke: "currentColor",
			strokeWidth: 1.42,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5836 7.34277C19.7309 8.36009 20.542 9.94476 20.542 11.9991C20.542 14.0536 19.7309 15.6382 18.5836 16.6555",
			stroke: "currentColor",
			strokeWidth: 1.42,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.18724 10.1472C4.07968 10.7286 4 11.3757 4 12C4 12.6244 4.07968 13.2713 4.18724 13.8529C4.39379 14.9695 5.28692 15.9007 6.47649 16.0606C6.77071 16.1 7.11313 16.1338 7.51669 16.1585C8.47862 16.2173 9.348 16.7247 9.86608 17.4916C10.069 17.792 10.2835 18.0853 10.5053 18.3634C11.5018 19.6139 13.0556 18.8917 13.1234 17.3287C13.18 16.0241 13.2254 14.2694 13.2254 12C13.2254 9.73056 13.18 7.97598 13.1234 6.67133C13.0556 5.10822 11.5018 4.38621 10.5053 5.63657C10.2835 5.91481 10.069 6.20799 9.86608 6.50844C9.348 7.27536 8.47862 7.78268 7.51669 7.84143C7.11313 7.86609 6.77071 7.89995 6.47649 7.93946C5.28692 8.09919 4.39379 9.03047 4.18724 10.1472Z",
			stroke: "currentColor",
			strokeWidth: 1.42,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSpeakerSimpleHigh;
